import { gql, useApolloClient, useMutation, } from '@apollo/client';
import { SIGNATORY_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const SIGNATORY_CREATE = gql `
    ${SIGNATORY_FIELDS}
    mutation createSignatory($dossierId: Long) {
      create_signatory(dossierId: $dossierId) {
        ...SignatoryFields
      }
    }
  `;
export const useSignatoryCreateMutation = (options) => useMutation(SIGNATORY_CREATE, options);
export const useSignatoryCreateMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: SIGNATORY_CREATE, variables }));
};
